import angular from 'angular';
import { MeurhAfastamentosService } from './afastamentos.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhAfastamentosListRouting = ['$stateProvider', function ($stateProvider: angular.ui.IStateProvider) {
    const resolve = {
        'entity': [
            'MeurhAfastamentosService',
            'ListagemService',
            '$rootScope',
            '$stateParams',
            '$state',
            '$q',
            function (
                entityService: MeurhAfastamentosService,
                listagemService: ListagemService,
                $rootScope: angular.IRootScopeService & {
                    session: any,
                    liberadoTela: (arg: string) => boolean
                },
                $stateParams: angular.ui.IStateParamsService,
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if (!$stateParams['solicitacao']) {
                    return $q<void>(() => $state.go('meurh_afastamentos'));
                }

                return entityService.get($stateParams['solicitacao'])
                    .then((data) => {
                        const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                        const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                        const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                        const deveRedirecionar = (
                            (visibilidadeLiberada && !empresaNoGrupo) ||
                            (!visibilidadeLiberada && !mesmoEstabelecimento)
                        );

                        if (deveRedirecionar) {
                            return $q(() => $state.go('meurh_afastamentos'));
                        }

                        return data;
                    })
                    .catch((error) => {
                        if (error.status === 404) {
                            return $q(() => {
                                if ($state.href('meurh_afastamentos_not_found', $stateParams)) {
                                    $state.go('meurh_afastamentos_not_found', $stateParams);
                                } else {
                                    $state.go('not_found', $stateParams);
                                }
                            });
                        }

                        return $q.reject(error);
                    });
            }
        ]
    };

    $stateProvider
        .state('meurh_afastamentos', {
            url: '/solicitacoes/afastamentos?q',
            template: require('html-loader!./index/afastamentos.index.html'),
            controller: 'Meurh\AfastamentosIndexController',
            controllerAs: 'mrh_afstmts_lst_cntrllr',
            reloadOnSearch: false
        })
        .state('meurh_afastamentos_new', {
            parent: 'meurh_afastamentos',
            url: '/new',
            template: require('html-loader!./new/afastamentos.new.html'),
            controller: 'MeurhAfastamentosNewController',
            controllerAs: 'mrh_afstmts_frm_nw_cntrllr'
        })
        .state('meurh_afastamentos_show', {
            parent: 'meurh_afastamentos',
            url: '/show/:solicitacao?path',
            resolve,
            template: require('html-loader!./show/afastamentos.show.html'),
            controller: 'MeurhAfastamentosShowController',
            controllerAs: 'mrh_afstmts_frm_shw_cntrllr'
        })
        .state('meurh_afastamentos_edit', {
            parent: 'meurh_afastamentos',
            url: '/edit/:solicitacao',
            resolve,
            template: require('html-loader!./edit/afastamentos.edit.html'),
            controller: 'Meurh\AfastamentosEditController',
            controllerAs: 'mrh_afstmts_frm_edit_cntrllr'
        });
    }
];
